import { render, staticRenderFns } from "./CardHistoricoEmails.vue?vue&type=template&id=beada844"
import script from "./CardHistoricoEmails.vue?vue&type=script&lang=js"
export * from "./CardHistoricoEmails.vue?vue&type=script&lang=js"
import style0 from "./CardHistoricoEmails.vue?vue&type=style&index=0&id=beada844&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports